import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    bancoCuentaId: 0,
    bancoCuenta: null,
    bancoCuentaNombre: null,
    bancoCuentaMonedaId: 0,
    bancoCuentaMoneda: null,
    bancoMovimientoTipoId: 0,
    bancoMovimientoTipo: null,
    bancoMovimientoTipoNombre: null,
    fechaEmision: moment(new Date()).format('YYYY-MM-DD'),
    fechaPago: moment(new Date()).format('YYYY-MM-DD'),
    fechaCreditoDebito: moment(new Date()).format('YYYY-MM-DD'),
    numero: 0,
    importe: 0,
    cotizacion: 1,
    proveedorId: 0,
    proveedor: null,
    proveedorNombre: null,
    premios: false,
    chequeEmpresa: false,
    observaciones: '',
    rowVersion: null,
    comprobanteAsociado: false,
    
    fechaEmisionPagoHabilitada: false,

    bancoCuentaDestinoId: 0,
    bancoCuentaDestino: null,
    bancoCuentaDestinoNombre: null,

    bancoMovimiento: null,
    bancoMovimientoDatos: [],
    readonly: false
};

const mutations = {
    updateField,

    'INICIALIZAR_BANCO_MOVIMIENTO'(state, bancoMovimientoId) {
        state.id = bancoMovimientoId;
        state.bancoCuentaId = 0;
        state.bancoCuenta = null;
        state.bancoCuentaNombre = null;
        state.bancoCuentaMonedaId = 0;
        state.bancoCuentaMoneda = null;
        state.bancoMovimientoTipoId = 0;
        state.bancoMovimientoTipo = null;
        state.bancoMovimientoTipoNombre = null;
        state.fechaEmision = moment(new Date()).format('YYYY-MM-DD');
        state.fechaPago = moment(new Date()).format('YYYY-MM-DD');
        state.fechaCreditoDebito = moment(new Date()).format('YYYY-MM-DD');
        state.numero = 0;
        state.importe = 0;
        state.cotizacion = 1;
        state.proveedorId = 0;
        state.proveedor = null;
        state.proveedorNombre = null;
        state.premios = false;
        state.chequeEmpresa = false;
        state.observaciones = '';
        state.rowVersion = null;
        state.comprobanteAsociado = false;
        
        state.fechaEmisionPagoHabilitada = false;

        state.bancoCuentaDestinoId = 0;
        state.bancoCuentaDestino = null;
        state.bancoCuentaDestinoNombre = null;
    },
    'INICIALIZAR_TRANSFERENCIA'(state) {
        state.id = 0;
        state.bancoCuentaId = 0;
        state.bancoCuenta = null;
        state.bancoCuentaNombre = null;
        state.bancoCuentaMonedaId = 0;
        state.bancoCuentaMoneda = null;
        state.bancoMovimientoTipoId = 6;
        state.bancoMovimientoTipo = {
            id: 6,
            nombre: 'TRANSFERENCIA (DEBITO)',
            credito: false
        };
        state.bancoMovimientoTipoNombre = 'TRANSFERENCIA (DEBITO)';
        state.fechaEmision = '1900-01-01';
        state.fechaPago = '1900-01-01';
        state.fechaCreditoDebito = moment(new Date()).format('YYYY-MM-DD');
        state.numero = 0;
        state.importe = 0;
        state.proveedorId = 0;
        state.proveedor = null;
        state.proveedorNombre = null;
        state.premios = false;
        state.chequeEmpresa = false;
        state.observaciones = '';
        state.rowVersion = null;
        state.comprobanteAsociado = false;

        state.fechaEmisionPagoHabilitada = false;

        state.bancoCuentaDestinoId = 0;
        state.bancoCuentaDestino = null;
        state.bancoCuentaDestinoNombre = null;
    },
    'SET_BANCO_MOVIMIENTO'(state, bancoMovimiento) {
        state.bancoCuentaId = (bancoMovimiento.bancoCuenta) ? bancoMovimiento.bancoCuenta.id : 0;
        state.bancoCuenta = bancoMovimiento.bancoCuenta;
        state.bancoCuentaNombre = (bancoMovimiento.bancoCuenta) ? bancoMovimiento.bancoCuenta.nombre.trim() : null;
        state.bancoCuentaMonedaId = (bancoMovimiento.bancoCuenta) ? bancoMovimiento.bancoCuentaMonedaId : 0;
        state.bancoCuentaMoneda = (bancoMovimiento.bancoCuenta) ? bancoMovimiento.bancoCuentaMoneda : null;
        state.bancoMovimientoTipoId = (bancoMovimiento.bancoMovimientoTipo) ? bancoMovimiento.bancoMovimientoTipo.id : 0;
        state.bancoMovimientoTipo = bancoMovimiento.bancoMovimientoTipo;
        state.bancoMovimientoTipoNombre = (bancoMovimiento.bancoMovimientoTipo) ? bancoMovimiento.bancoMovimientoTipo.nombre.trim() : null;
        state.fechaEmision = moment(bancoMovimiento.fechaEmision).format('YYYY-MM-DD');
        state.fechaPago = moment(bancoMovimiento.fechaPago).format('YYYY-MM-DD');
        state.fechaCreditoDebito = moment(bancoMovimiento.fechaCreditoDebito).format('YYYY-MM-DD');
        state.numero = bancoMovimiento.numero;
        state.importe = bancoMovimiento.importe;
        state.cotizacion = bancoMovimiento.cotizacion;
        state.proveedorId = (bancoMovimiento.proveedor) ? bancoMovimiento.proveedor.id : 0;
        state.proveedor = bancoMovimiento.proveedor;
        state.proveedorNombre = (bancoMovimiento.proveedor) ? bancoMovimiento.proveedor.nombre.trim() : null;
        state.premios = (/true/i).test(bancoMovimiento.premios);
        state.chequeEmpresa = (/true/i).test(bancoMovimiento.chequeEmpresa);
        state.observaciones = bancoMovimiento.observaciones.trim();
        state.rowVersion = bancoMovimiento.rowVersion;
        state.comprobanteAsociado = bancoMovimiento.comprobanteAsociado;

        state.fechaEmisionPagoHabilitada = state.bancoMovimientoTipoId == 1? true : false;
    },
    'SET_BANCO_CUENTA'(state, bancoCuenta) {
        state.bancoCuenta = bancoCuenta;
        if (bancoCuenta) {
            state.bancoCuentaId = bancoCuenta.id ? bancoCuenta.id : 0;
            state.bancoCuentaNombre = bancoCuenta.nombre ? bancoCuenta.nombre.trim() : null;
            state.bancoCuentaMonedaId = bancoCuenta.monedaId ? bancoCuenta.monedaId : 0;
            state.bancoCuentaMoneda = bancoCuenta.moneda ? bancoCuenta.moneda.trim() : null;
        } else {
            state.bancoCuentaId = 0;
            state.bancoCuentaNombre = null;
            state.bancoCuentaMonedaId = 0;
            state.bancoCuentaMoneda = null;
        }
    },
    'SET_BANCO_MOVIMIENTO_TIPO'(state, bancoMovimientoTipo) {
        state.bancoMovimientoTipo = bancoMovimientoTipo;
        if (bancoMovimientoTipo) {
            state.bancoMovimientoTipoId = bancoMovimientoTipo.id ? bancoMovimientoTipo.id : 0;
            state.bancoMovimientoTipoNombre = bancoMovimientoTipo.nombre ? bancoMovimientoTipo.nombre.trim() : null;
        } else {
            state.bancoMovimientoTipoId = 0;
            state.bancoMovimientoTipoNombre = null;
        }

        state.fechaEmisionPagoHabilitada = state.bancoMovimientoTipoId == 1? true : false;
    },
    'SET_PROVEEDOR'(state, proveedor) {
        state.proveedor = proveedor;
        if (proveedor) {
            state.proveedorId = proveedor.id? proveedor.id : 0;
            state.proveedorNombre = proveedor.nombre? proveedor.nombre.trim() : null;
        } else {
            state.proveedorId = 0;
            state.proveedorNombre = null;
        }
    },
    'SET_BANCO_CUENTA_DESTINO'(state, bancoCuentaDestino) {
        state.bancoCuentaDestino = bancoCuentaDestino;
        if (bancoCuentaDestino) {
            state.bancoCuentaDestinoId = bancoCuentaDestino.id? bancoCuentaDestino.id : 0;
            state.bancoCuentaDestinoNombre = bancoCuentaDestino.nombre? bancoCuentaDestino.nombre.trim() : null;
        } else {
            state.bancoCuentaDestinoId = 0;
            state.bancoCuentaDestinoNombre = null;
        }
    },

    'INICIALIZAR_BANCO_MOVIMIENTO_DATOS' (state) {
        state.bancoMovimiento = [];
        state.bancoMovimientoDatos = [];
        state.readonly = false;
    },
    'SET_BANCO_MOVIMIENTO_DATOS' (state, params) {
        state.bancoMovimiento = params.bancoMovimiento;
        state.bancoMovimientoDatos = params.bancoMovimientoDatos;
        state.readonly = params.readonly;
    }
};

const getters = {
    getField,

    bancoMovimiento(state) {
        return state.bancoMovimiento;
    }
};

const actions = {
    inicializar ( { commit }, bancoMovimientoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO_MOVIMIENTO', bancoMovimientoId);

            let getBancoMovimiento = false;
            if (bancoMovimientoId) {
                if (bancoMovimientoId != 0) {
                    getBancoMovimiento = true;
                }
            }

            if (getBancoMovimiento) {
                apiAxios.get(`bancosmovimientos/${bancoMovimientoId}/abm` ) 
                    .then(res => {
                        commit('SET_BANCO_MOVIMIENTO', res.data);
                        resolve();
                        //reject('Error de prueba');
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    inicializarTransferencia ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TRANSFERENCIA');
            resolve();
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let debe = 0;
            let haber = 0;
            
            if (state.bancoMovimientoTipo) {
                if ((/true/i).test(state.bancoMovimientoTipo.credito)) {
                    debe = state.importe;
                } else {
                    haber = state.importe;
                }
            }

            let numero = 0;
            if (state.numero) {
                numero = parseInt(state.numero);
            }
            
            let fechaEmision = moment(state.fechaEmision).format('YYYY-MM-DD');
            let fechaPago = moment(state.fechaPago).format('YYYY-MM-DD');
            let fechaCreditoDebito = moment(state.fechaCreditoDebito).format('YYYY-MM-DD');
            let chequeEmpresa = (/true/i).test(state.chequeEmpresa);

            if (state.bancoMovimientoTipoId == 1) {
                fechaCreditoDebito = fechaPago;
            } else {
                fechaEmision = '1900-01-01';
                fechaPago = '1900-01-01';
                chequeEmpresa = false;
            }

            let bancoMovimiento = {
                bancoCuentaId: parseInt(state.bancoCuentaId),
                bancoMovimientoTipoId: parseInt(state.bancoMovimientoTipoId),
                fechaEmision,
                fechaPago,
                fechaCreditoDebito,
                numero: numero,
                debe: parseFloat(debe),
                haber: parseFloat(haber),
                cotizacion: parseFloat(state.cotizacion),
                proveedorId: parseInt(state.proveedorId),
                premios: (/true/i).test(state.premios),
                chequeEmpresa,
                observaciones: state.observaciones.trim().toUpperCase(),

                bancoCuentaDestinoId: state.bancoCuentaDestinoId,
            }

            let url = 'bancosmovimientos';
            if (state.id != 0) {
                bancoMovimiento.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }

            apiAxios.post(url, bancoMovimiento)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    saveTransferenciaPremios ( { state } ) {
        return new Promise((resolve, reject) => {
            let transferencia = {
                bancoCuentaId: parseInt(state.bancoCuentaId),
                fechaCreditoDebito: moment(state.fechaCreditoDebito).format('YYYY-MM-DD'),
                importe: state.importe,
                premios: true,
                observaciones: state.observaciones.trim().toUpperCase(),
                // presupuestoInternoId: state.presupuestoInternoId
            }

            apiAxios.post('bancosmovimientos/premios', transferencia)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setBancoCuenta: ({commit}, bancoCuenta) => {
        commit('SET_BANCO_CUENTA', bancoCuenta);
    },
    setBancoMovimientoTipo: ({commit}, bancoMovimientoTipo) => {
        commit('SET_BANCO_MOVIMIENTO_TIPO', bancoMovimientoTipo);
    },
    setProveedor: ({commit}, proveedor) => {
        commit('SET_PROVEEDOR', proveedor);
    },
    setBancoCuentaDestino: ({commit}, bancoCuentaDestino) => {
        commit('SET_BANCO_CUENTA_DESTINO', bancoCuentaDestino);
    },

    getBancoMovimientoDatos ( { commit }, bancoMovimientoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO_MOVIMIENTO_DATOS');

            if (bancoMovimientoId != 0) {
                apiAxios.get('bancosmovimientos/' + bancoMovimientoId ) 
                .then(res => {
                    let bancoMovimientoDatos = [];

                    const importe = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.importe)}`;

                    if (res.data.bancoMovimientoTipoId == 1) {
                        bancoMovimientoDatos = [
                            { 'nombre': 'bancoCuenta', 'campo': 'Cuenta', 'valor': res.data.bancoCuenta, 'formato': '' },
                            { 'nombre': 'bancoMovimientoTipo', 'campo': 'Movimiento', 'valor': res.data.bancoMovimientoTipo, 'formato': '' },
                            { 'nombre': 'fechaEmision', 'campo': 'Fecha Emisión', 'valor': res.data.fechaEmision, 'formato': 'fecha' },
                            { 'nombre': 'fechaPago', 'campo': 'Fecha Pago', 'valor': res.data.fechaPago, 'formato': 'fecha' },
                            { 'nombre': 'fechaCreditoDebito', 'campo': 'Fecha Cred/Deb', 'valor': res.data.fechaCreditoDebito, 'formato': 'fecha' },
                            { 'nombre': 'proveedor', 'campo': 'Proveedor', 'valor': res.data.proveedor, 'formato': '' },
                            { 'nombre': 'chequeEmpresa', 'campo': 'A nombre de la empresa', 'valor': res.data.chequeEmpresa? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'numero', 'campo': 'Número', 'valor': res.data.numero, 'formato': '' },
                            { 'nombre': 'importe', 'campo': 'Importe', 'valor': importe, 'formato': '' }
                        ];

                        if (res.data.cotizacion != 0 && res.data.cotizacion != 1) {
                            bancoMovimientoDatos.push({ 'nombre': 'cotizacion', 'campo': 'Cotización', 'valor': res.data.cotizacion, 'formato': 'moneda' });
                        }
                        if (res.data.estado != '') {
                            bancoMovimientoDatos.push({ 'nombre': 'estado', 'campo': 'Estado', 'valor': res.data.estado, 'formato': '' });
                        }
                        bancoMovimientoDatos.push(
                            { 'nombre': 'observaciones', 'campo': 'Referencia', 'valor': res.data.observaciones, 'formato': '' },
                            { 'nombre': 'referencia', 'campo': 'Movimiento Asociado', 'valor': res.data.referencia, 'formato': '' });

                    } else {
                        bancoMovimientoDatos = [
                            { 'nombre': 'bancoCuenta', 'campo': 'Cuenta', 'valor': res.data.bancoCuenta, 'formato': '' },
                            { 'nombre': 'bancoMovimientoTipo', 'campo': 'Movimiento', 'valor': res.data.bancoMovimientoTipo, 'formato': '' },
                            { 'nombre': 'fechaCreditoDebito', 'campo': 'Fecha Cred/Deb', 'valor': res.data.fechaCreditoDebito, 'formato': 'fecha' },
                            { 'nombre': 'proveedor', 'campo': 'Proveedor', 'valor': res.data.proveedor, 'formato': '' },
                            { 'nombre': 'numero', 'campo': 'Número', 'valor': res.data.numero, 'formato': '' },
                            { 'nombre': 'importe', 'campo': 'Importe', 'valor': importe, 'formato': '' }
                        ];

                        if (res.data.cotizacion != 0 && res.data.cotizacion != 1) {
                            bancoMovimientoDatos.push({ 'nombre': 'cotizacion', 'campo': 'Cotización', 'valor': res.data.cotizacion, 'formato': 'moneda' });
                        }
                        
                        bancoMovimientoDatos.push({ 'nombre': 'observaciones', 'campo': 'Referencia', 'valor': res.data.observaciones, 'formato': '' });

                        if (res.data.premios) {
                            bancoMovimientoDatos.push({ 'nombre': 'referencia', 'campo': 'Premios', 'valor': res.data.referencia, 'formato': '' });
                        } else if (res.data.referencia) {
                            bancoMovimientoDatos.push({ 'nombre': 'referencia', 'campo': 'Movimiento Asociado', 'valor': res.data.referencia, 'formato': '' });
                        }
                    }
                    
                    let params = {
                        bancoMovimientoDatos,
                        bancoMovimiento: res.data,
                        readonly: (/true/i).test(res.data.readonly)
                    }
                    commit('SET_BANCO_MOVIMIENTO_DATOS', params);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    getBancoMovimientoDatosByNumero ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO_MOVIMIENTO_DATOS');

            if (params) {
                let queryString = '?bancoCuentaId=' + params.bancoCuentaId
                    + '&bancoMovimientoTipoId= ' + params.bancoMovimientoTipoId
                    + '&numero=' + params.numero;

                apiAxios.get('bancosmovimientos/numero' + queryString) 
                .then(res => {
                    let bancoMovimientoDatos = [];
                    
                    const importe = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.importe)}`;

                    if (res.data.bancoMovimientoTipoId == 1) {
                        bancoMovimientoDatos = [
                            { 'nombre': 'bancoCuenta', 'campo': 'Cuenta', 'valor': res.data.bancoCuenta, 'formato': '' },
                            { 'nombre': 'bancoMovimientoTipo', 'campo': 'Movimiento', 'valor': res.data.bancoMovimientoTipo, 'formato': '' },
                            { 'nombre': 'fechaEmision', 'campo': 'Fecha Emisión', 'valor': res.data.fechaEmision, 'formato': 'fecha' },
                            { 'nombre': 'fechaPago', 'campo': 'Fecha Pago', 'valor': res.data.fechaPago, 'formato': 'fecha' },
                            { 'nombre': 'fechaCreditoDebito', 'campo': 'Fecha Cred/Deb', 'valor': res.data.fechaCreditoDebito, 'formato': 'fecha' },
                            { 'nombre': 'proveedor', 'campo': 'Proveedor', 'valor': res.data.proveedor, 'formato': '' },
                            { 'nombre': 'numero', 'campo': 'Número', 'valor': res.data.numero, 'formato': '' },
                            { 'nombre': 'importe', 'campo': 'Importe', 'valor': importe, 'formato': '' }
                        ];
                        if (res.data.cotizacion != 0 && res.data.cotizacion != 1) {
                            bancoMovimientoDatos.push({ 'nombre': 'cotizacion', 'campo': 'Cotización', 'valor': res.data.cotizacion, 'formato': 'moneda' });
                        }
                        bancoMovimientoDatos.push(
                            { 'nombre': 'observaciones', 'campo': 'Referencia', 'valor': res.data.observaciones, 'formato': '' },
                            { 'nombre': 'referencia', 'campo': 'Movimiento Asociado', 'valor': res.data.referencia, 'formato': '' });
                    } else {
                        bancoMovimientoDatos = [
                            { 'nombre': 'bancoCuenta', 'campo': 'Cuenta', 'valor': res.data.bancoCuenta, 'formato': '' },
                            { 'nombre': 'bancoMovimientoTipo', 'campo': 'Movimiento', 'valor': res.data.bancoMovimientoTipo, 'formato': '' },
                            { 'nombre': 'fechaCreditoDebito', 'campo': 'Fecha Cred/Deb', 'valor': res.data.fechaCreditoDebito, 'formato': 'fecha' },
                            { 'nombre': 'proveedor', 'campo': 'Proveedor', 'valor': res.data.proveedor, 'formato': '' },
                            { 'nombre': 'numero', 'campo': 'Número', 'valor': res.data.numero, 'formato': '' },
                            { 'nombre': 'importe', 'campo': 'Importe', 'valor': importe, 'formato': '' }
                        ];
                        if (res.data.cotizacion != 0 && res.data.cotizacion != 1) {
                            bancoMovimientoDatos.push({ 'nombre': 'cotizacion', 'campo': 'Cotización', 'valor': res.data.cotizacion, 'formato': 'moneda' });
                        }
                        bancoMovimientoDatos.push(
                            { 'nombre': 'observaciones', 'campo': 'Referencia', 'valor': res.data.observaciones, 'formato': '' },
                            { 'nombre': 'referencia', 'campo': 'Movimiento Asociado', 'valor': res.data.referencia, 'formato': '' });
                    }
                    
                    let params = {
                        bancoMovimientoDatos,
                        bancoMovimiento: res.data 
                    }
                    commit('SET_BANCO_MOVIMIENTO_DATOS', params);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },

    depositarChequeTerceros ( {}, params ) {
        return new Promise((resolve, reject) => {
            
            let chequeTerceroDeposito = {
                bancoCuentaId: params.bancoCuentaId,
                chequeTerceroId: params.chequeTerceroId,
                fechaCreditoDebito: params.fechaCreditoDebito 
            };

            let url = 'bancosmovimientos/depositar';

            apiAxios.post(url, chequeTerceroDeposito)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    actualizarCuenta ( {}, params ) {
        return new Promise((resolve, reject) => {
            let actualizacion = {
                bancoCuentaDestinoId: params.bancoCuentaDestinoId,
            };

            apiAxios.post(`bancosmovimientos/${params.bancoMovimientoId}/actualizar-cuenta`, actualizacion)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}